import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { fuseAnimations } from '@fuse/animations';


@Component({
    selector     : 'alert-dialog',
    templateUrl  : './alertdialog.component.html',
    styleUrls    : ['./alertdialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations : fuseAnimations
})

export class AlertDialogComponent{

    constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}


    onNoClick(): void {
	    this.dialogRef.close('false');
	}

    okOnclick(): void {
        this.dialogRef.close('true');
      }


}
